/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipReportEvidenceExportUrlQueryResponse, AuditReportsGetGipReportEvidenceExportUrlPathParams, AuditReportsGetGipReportEvidenceExportUrl401, AuditReportsGetGipReportEvidenceExportUrl403, AuditReportsGetGipReportEvidenceExportUrl404 } from "../models/AuditReportsGetGipReportEvidenceExportUrl";

export function getAuditReportsGetGipReportEvidenceExportUrlUrl(id: AuditReportsGetGipReportEvidenceExportUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/report/${id}/evidence-export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip/report/:id/evidence-export-url}
 */
export async function auditReportsGetGipReportEvidenceExportUrl(id: AuditReportsGetGipReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportEvidenceExportUrl401 | AuditReportsGetGipReportEvidenceExportUrl403 | AuditReportsGetGipReportEvidenceExportUrl404>, unknown>({ method : "GET", url : getAuditReportsGetGipReportEvidenceExportUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}